module["exports"] = [
  "#{city_prefix}"
];



//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/en_ZA/address/city.js
// module id = 2768
// module chunks = 1609